import React from "react";
import { Row, Col } from "react-bootstrap";
import "./ModalSkeleton.css";

const ModalSkeleton = () => {
  return (
    <div className="modal-skeleton-wrapper">
      {/* Header Skeleton */}
      {/* <div className="modal-header">
        <div className="h-4 w-48 bg-gray-300 rounded mb-0 skeleton-shimmer"></div>
        <div
          className="btn-close skeleton-shimmer"
          style={{ opacity: 0.3 }}
        ></div>
      </div> */}

      {/* Body Skeleton */}
      <div className="modal-body" style={{ minHeight: "600px" }}>
        {/* Base Point Selector Skeleton */}
        <div className="mb-3">
          <div className="h-5 w-40 bg-gray-300 rounded mb-3 skeleton-shimmer"></div>
          <div className="d-flex gap-2 flex-wrap">
            {[1, 2, 3].map((i) => (
              <div key={i} className="skeleton-card">
                <div className="h-4 w-20 bg-gray-300 rounded mb-2 skeleton-shimmer"></div>
                <div className="h-16 w-48 bg-gray-200 rounded skeleton-shimmer"></div>
              </div>
            ))}
          </div>
        </div>

        <Row>
          {/* Panel Lateral Skeleton */}
          <Col md={4}>
            <div className="p-2 bg-light rounded shadow-sm">
              {/* Radio de búsqueda título */}
              <div className="h-5 w-32 bg-gray-300 rounded mb-2 skeleton-shimmer"></div>

              {/* Botones de radio */}
              <div className="d-flex gap-2 mb-3 flex-wrap">
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className="h-10 bg-gray-200 rounded skeleton-shimmer"
                    style={{ width: "80px" }}
                  ></div>
                ))}
              </div>

              {/* Lista de órdenes cercanas */}
              <div className="mb-2">
                <div className="h-4 w-36 bg-gray-300 rounded mb-3 skeleton-shimmer"></div>
                <div className="skeleton-orders-list">
                  {[1, 2, 3, 4].map((i) => (
                    <div
                      key={i}
                      className="mb-2 p-2 bg-gray-100 rounded skeleton-shimmer"
                      style={{ height: "80px" }}
                    >
                      <div className="h-4 w-24 bg-gray-300 rounded mb-2 skeleton-shimmer"></div>
                      <div className="h-3 w-full bg-gray-200 rounded mb-1 skeleton-shimmer"></div>
                      <div className="h-3 w-3/4 bg-gray-200 rounded skeleton-shimmer"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Col>

          {/* Mapa Skeleton */}
          <Col md={8}>
            <div
              className="bg-gray-200 rounded skeleton-shimmer"
              style={{ width: "100%", height: "600px" }}
            ></div>
          </Col>
        </Row>
      </div>

      {/* Footer Skeleton */}
      <div className="modal-footer">
        <div
          className="h-10 bg-gray-200 rounded skeleton-shimmer"
          style={{ width: "100px" }}
        ></div>
      </div>

      {/* Spinner centrado */}
      <div className="modal-skeleton-spinner">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    </div>
  );
};

export default ModalSkeleton;
